import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const postGoogleOAuthSignIn: DocumentNode = gql`
  mutation PostGoogleOAuthSignIn($input: GoogleOAuthSignInInput!, $productName: OutputLoginProductName) {
    postGoogleOAuthSignIn(input: $input, productName: $productName) {
      apiKey
      refreshToken
    }
  }
`

export default postGoogleOAuthSignIn
